module.exports = __webpack_public_path__ + "img/ic_setting notification.bf9d7737.svg";